import { useFormikContext } from 'formik';
import { soundType } from 'lib/const/notifications';
import * as React from 'react';
import { Button } from 'react-covideo-common';
import { MdPlayArrow } from 'react-icons/md';
import { Container, RowWrapper, SectionTitle } from './common/components';
import { getPreferenceSounds } from './common/constants';
import { useTranslation } from 'react-i18next';
import { FormikDropdownField } from 'lib/components/formik/FormikDropdown';
import { Flex, FlexProps } from 'lib/components/styles/layout';

const playSound = (sound: string = 'piano') => {
  sound = sound.toLowerCase().replaceAll(' ', '');
  if (soundType[sound]) {
    new Audio(soundType[sound]).play();
  }
};

const extendStyles = {
  labelStyles: {
    minWidth: '125px',
    maxWidth: '125px',
    maxHeight: '40px',
  },
  mainWrapper: { flexDirection: 'row' },
} as {
  labelStyles: React.CSSProperties;
  mainWrapper: FlexProps;
};

export const NotificationSoundComponent = () => {
  interface FormValues {
    notificationPreferences?: {
      sound?: string;
    };
  }

  const { values, isSubmitting } = useFormikContext<FormValues>();
  const { t } = useTranslation();
  const preferenceSoundOptions = getPreferenceSounds(t).map(sound => ({
    label: sound.name,
    value: sound.value,
  }));

  const selectedSoundValue = values?.notificationPreferences?.sound;

  return (
    <Container>
      <SectionTitle>{t('Notification Sound')}</SectionTitle>
      <RowWrapper>
        <Flex
          flexDirection='row'
          alignItems='flex-start'
          width='100%'
          justifyContent='space-between'
          gap='16px'
        >
          <FormikDropdownField
            name={'notificationPreferences.sound'}
            options={preferenceSoundOptions}
            label='Select Sound'
            disabled={isSubmitting}
            extendStyles={extendStyles}
          />
          <Button
            disabled={isSubmitting}
            variant='secondary'
            onClick={() => {
              playSound(selectedSoundValue);
            }}
            icon={<MdPlayArrow height={40} width={40} />}
          />
        </Flex>
      </RowWrapper>
    </Container>
  );
};
